// extracted by mini-css-extract-plugin
export var container = "_4h-0";
export var icon = "_4h-1";
export var text = "_4h-2";